<template>
  <!-- HTML 에디터 -->
    <content-editor
        v-if="editor_version==1"
        style="height: 100%"
        ref="editor"
        @getHtmlReturn="getHtmlReturn"
        @getPageInfo="getPageInfo"
    />
    <content-editor2
        v-else-if="editor_version==2"
        style="height: 100%"
        ref="editor"
        @getHtmlReturn="getHtmlReturn"
        @getPageInfo="getPageInfo"
    />
</template>
<script>
import {mapMutations, mapGetters} from 'vuex'
import ContentEditor2 from "@/components/ContentEditor2";
import ContentEditor from "@/components/ContentEditor";
import axios from "axios";
export default {
  components:{
    ContentEditor2,
    ContentEditor,
  },
  computed:mapGetters({
    login: 'login', // 로그인 상태
  }),
  data: () => ({
    editor_version: 1
  }),
  methods: {
    getEditor(pageId){
      const thisObj = this;
      this.$http
          .get('/api_home/editor?pageId=' + pageId)
          .then(function(obj){
            if(obj.data.tempUser != 1){
              thisObj.loginRequired = 0
            }
            thisObj.pageInfo = obj.data.pageInfo;
            thisObj.editor_version = obj.data.pageInfo.editor_version;
            const domain = window.location.protocol + '//' + window.location.host;
            thisObj.setHtml(thisObj.pageInfo.html, obj.data.tempUser, domain, obj.data);
          })
          .catch(function(err){
            if(err.response.data.error_message == 'ERR04, 정보가 없습니다.'){
              this.$eventBus.$emit('error','존재하지 않거나 접근 불가능한 페이지입니다.')
              return;
            }
          })
    },
    viewPage(){
      const thisObj = this;
      if(thisObj.pageInfo.pageUrl == null && thisObj.pageInfo.rootYn != 1){ // 페이지 URL이 미설정시
        this.$eventBus.$emit('error','페이지 URL 설정이 필요합니다.')
        return;
      }
      window.open(thisObj.pageInfo.fullUrl, '_blank')
    },
    putEditor: function(){
      this.$refs.editor.getHtml();
    },
    getHtmlReturn(html, maxWidth){
      var thisObj = this;
      const axios_data = {
        editorId: thisObj.pageInfo.editorId,
        html: html,
        maxWidth: maxWidth
      };
      this.$http
          .put('/api_home/editor', axios_data)
          .then(obj=>{
            this.$eventBus.$emit('info', '저장 완료')
          })
          .catch(err=>{
            console.warn(err.response);})
    },
    setHtml: function(html, tempUser, domain, data){
      this.$refs.editor.setHtml(html, tempUser, domain, data);
    },
    setIframe: function(){
      const iframe_url = 'http://m2.snadx.com:31070/instagram?instagramUserId=myshop_shockping';
      this.$refs.editor.setIframe(iframe_url);
    },
    getPageInfo(){
      // DB에 저장된 페이지 내용을 불러와 에디터에 세팅
      this.getEditor(this.$route.query.pageId);
    },
  },
  mounted: function() {

    //this.$eventBus.$emit('error', '페이지 URL 설정이 필요합니다.')

    // 네비게이션 설정
    //this.$store.commit('nav_name','페이지 편집')
    //this.$store.commit('page_name','페이지 편집')

    // 페이지 <html> 태그의 CSS 변경 - overflow: hidden

    return

    document.getElementsByTagName('html')[0].style.overflow = 'hidden';

    // 페이지이동 & 창닫기 이벤트 발생시
    window.addEventListener("beforeunload", function(e){
      e.preventDefault(); // 표준에 따라 기본 동작 방지
      e.returnValue = ''; // Chrome에서는 returnValue 설정이 필요함
    });
  },
}
</script>